import {createAction, props} from '@ngrx/store';
import {UserInterface} from '@core/model/user/user.interface';

export const userList = createAction(
  '[User-Chooser-component] get user list'
);
export const userListSuccess = createAction(
  '[User-Chooser-component] get user list success',
  props<{ users: Array<UserInterface> }>()
);
